/**
 * ADDON CART GUARD
 * Enforces: Add-on products (product.type == "Add-on") can only be purchased
 * alongside a Bundle or Custom Box item already in the cart. Re-evaluates on
 * every cart change via the theme's existing PUB_SUB_EVENTS.cartUpdate bus,
 * so it covers product-page add-to-cart, cart drawer, and cart page changes
 * without polling or extra fetches.
 */
(function () {
  function cartHasBox(items) {
    return items.some(function (item) {
      return item.product_type === 'Bundle' || item.product_type === 'Custom Box';
    });
  }

  function updateProductForms(hasBox) {
    document.querySelectorAll('product-form[data-requires-box]').forEach(function (form) {
      // Product page uses #ProductSubmitButton-<sectionId> / .product-form__submit;
      // the collection-card quick-add form (single-variant Add-ons) uses its
      // own .quick-add__submit button — same guard, different markup.
      var btn =
        form.querySelector('#ProductSubmitButton-' + form.dataset.sectionId) ||
        form.querySelector('.product-form__submit') ||
        form.querySelector('.quick-add__submit');
      var notice = form.querySelector('.addon-requires-box-notice');
      if (btn) btn.disabled = !hasBox;
      if (notice) notice.hidden = hasBox;
    });
  }

  function updateCartWarningBanner(hasAddonWithoutBox) {
    document.querySelectorAll('.addon-orphan-warning').forEach(function (banner) {
      banner.hidden = !hasAddonWithoutBox;
    });
  }

  function evaluate(items) {
    var hasBox = cartHasBox(items);
    var hasAddon = items.some(function (item) { return item.product_type === 'Add-on'; });
    updateProductForms(hasBox);
    updateCartWarningBanner(hasAddon && !hasBox);
  }

  function refreshFromServer() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { evaluate(cart.items || []); })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var items = event && event.cartData && event.cartData.items;
      if (items) {
        evaluate(items);
      } else {
        refreshFromServer();
      }
    });
  }

  document.addEventListener('cart:refresh', refreshFromServer);

  // Also check on page load, not just after a cart change — otherwise a
  // customer who lands on an Add-on's page with a box already in their
  // cart from an earlier visit sees the server-rendered (Liquid) state
  // until the next cart event fires.
  refreshFromServer();
})();
